import { useState } from 'react'
import { useAuth } from 'ict24h-themes-react'
import { ProjectEntity } from '../../../../../server-api-hrm.type'
import commonRequestHandler from '../../../../../utils/common-request-handler'
import requestErrorHandler from '../../../../../utils/request-error-handler'
import { deleteProject } from '../project.service'
import { setMenuRefetchSignal } from '../stores/project-reducer'

type RequestFailType = 'SERVER' | 'RESOURCE' | 'OTHER'

type Params = {
  onFinish?: (_res: ProjectEntity) => void
  onFail?: (_failType: RequestFailType) => void
  customRequestHandler?: boolean
}

const useDeleteProject = (params: Params = {}) => {
  const { token } = useAuth()

  const [loading, setLoading] = useState(false)

  const handleDelete = async (id: string, localHandler: Params = {}) => {
    const onFinish = localHandler?.onFinish || params.onFinish
    const onFail = localHandler?.onFail || params.onFail
    const customRequestHandler =
      localHandler?.customRequestHandler ?? params.customRequestHandler

    const requestHandler = customRequestHandler
      ? requestErrorHandler
      : commonRequestHandler

    setLoading(true)
    const res = await deleteProject(token, { id })
    setLoading(false)
    if (!res) {
      if (typeof onFail === 'function') onFail('OTHER')
      return
    }
    requestHandler({
      status: res?.status,
      action: 'mutate',
      onSuccess: () => {
        if (typeof onFinish === 'function') onFinish(res.data)
        setMenuRefetchSignal({
          type: res.data?.departmentId
            ? 'DEPARTMENT_PROJECT'
            : 'GENERAL_PROJECT',
          action: 'D',
        })
      },
      onResourceFail: () => {
        if (typeof onFail === 'function') onFail('RESOURCE')
      },
      onServerFail: () => {
        if (typeof onFail === 'function') onFail('SERVER')
      },
    })
  }

  return {
    loading,
    handleDelete,
  }
}

export default useDeleteProject
